import { useTranslation } from 'react-i18next';
import { Box, Typography, Chip, CircularProgress, IconButton } from '@mui/material';
import ScheduleIcon from '@mui/icons-material/Schedule';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import CloseIcon from '@mui/icons-material/Close';
import { TASK_STATUS } from '../../../../../constants/activityCenter';

const getStatusDisplay = (status) => {
  switch (status) {
    case TASK_STATUS.QUEUED:
      return { icon: <ScheduleIcon />, color: 'info' };
    case TASK_STATUS.IN_PROGRESS:
      return { icon: <CircularProgress size={16} />, color: 'warning' };
    case TASK_STATUS.COMPLETED:
      return { icon: <CheckCircleIcon />, color: 'success' };
    case TASK_STATUS.FAILED:
      return { icon: <ErrorIcon />, color: 'error' };
    default:
      return { icon: null, color: 'default' };
  }
};

const TaskHeader = ({ title, status, onClear }) => {
  const { t } = useTranslation();
  const statusDisplay = getStatusDisplay(status);

  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      mb: 1,
    }}
    >
      <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
        {title}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Chip
          icon={statusDisplay.icon}
          label={t(`ActivityCenter_Status_${status}`)}
          color={statusDisplay.color}
          size="small"
          clickable={false}
        />
        <IconButton
          size="small"
          onClick={onClear}
          sx={{
            color: 'text.secondary',
          }}
          aria-label={t('ActivityCenter_ClearTask')}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
};

export default TaskHeader;
